/**
 * Common chart styling constants
 * Provides reusable style objects for consistent chart appearance
 */

// Style to remove focus outlines from chart elements
export const chartNoOutlineStyle = { outline: 'none' } as const;

// Common chart element styles
export const chartStyles = {
  noOutline: chartNoOutlineStyle,
} as const;
